import { FC, useEffect } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { AppMenuKey, AppMenuSectionItem } from "../../../../../common/routesUtils";
import MultiValueWidget from "../../../../../components/charts/MultiValueWidget";
import { View } from "../../../../../components/layout/View";
import { PageType } from "../../../../../config/page.types";
import { useBreadcrumbs } from "../../../../../context/BreadcrumbsProvider";
import { ThirdPartyTripDetailsDTO } from "../../../../../datasources/api-client/data-contracts";
import { ApiRoutes } from "../../../../../datasources/networking/apiRoutes";
import { useReadResource } from "../../../../../hooks/useResource";
import { displayValuesThirdParty } from "./data";

interface Props {
	menuKeys?: Array<AppMenuKey>;
	path?: Array<AppMenuSectionItem>;
}

/**
 * Renders the transport trip details page
 * @param param0
 * @returns
 */
const TransportThirdPartyDetail: FC<Props> = ({ menuKeys, path }) => {
	const { t, i18n } = useTranslation("result.transport");
	const { visitPage } = useBreadcrumbs();

	const params = useParams();
	const id = params.id || "1"; // NOTE: redirect in case of id not given

	useEffect(() => {
		if (id) {
			visitPage(PageType.ResultsTransportGreenRouterDetail, false, id);
		}
	}, [id, visitPage]);

	const { data, isLoading } = useReadResource<undefined, ThirdPartyTripDetailsDTO>({
		route: ApiRoutes.ResultsTransportThirdPartyDetail,
		path: { id: id },
	});

	const { emissions, transportData } = displayValuesThirdParty(data, t, i18n.language);

	return (
		<View pageType={PageType.ResultsTransportThirdPartyDetail}>
			<Grid container spacing={3}>
				<Grid size={12} minHeight={200}>
					<MultiValueWidget
						isLoading={isLoading}
						values={emissions}
						valueVariant="body1"
						title={t("emissions")}
						elementsPerRow={4}
					/>
				</Grid>
				<Grid size={12} minHeight={128}>
					<MultiValueWidget
						isLoading={isLoading}
						values={transportData}
						valueVariant="body1"
						title={t("transport data")}
						elementsPerRow={6}
					/>
				</Grid>
			</Grid>
		</View>
	);
};

export default TransportThirdPartyDetail;
